import React, { useState } from "react";
import { usePresence } from "../hooks/usePresence";
import { Switch, makeStyles } from "@fluentui/react-components";
import {Tooltip, tokens,} from '@fluentui/react-components';
import { 
  PresenceAvailableFilled, 
  PresenceAwayFilled,
  PresenceBusyFilled,
  PresenceDndFilled,
  PresenceOfflineRegular,
  PresenceOofRegular,
  PresenceUnknownRegular,
  PresenceTentativeRegular,
  PresenceBlockedRegular,
} from "@fluentui/react-icons";

const useStyles = makeStyles({
  presenceContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: "60%",
  },
  presenceRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  toggleDnd: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  infoIcon: {
    cursor: 'pointer',
  },
  oofMessage: {
    wordWrap: 'break-word',
    fontSize: '0.85rem',
    backgroundColor: '#F3F2F1',
    borderLeft: '4px solid #6B4C9A',
    padding: '4px 0',
    color: '#333',
  },
  switchNoMargin: {
    // remove margin on the indicator slot
    [`& .fui-Switch__indicator`]: {
      margin: 0,
    },
  },
  psIconWrapper: {
    display: "inline-flex",
    alignItems: "center",
    fontSize: "large",
  }
});

export default function PresenceIndicator() {
  const styles = useStyles();
  const { presence, loading, error, setPresenceState } = usePresence();
  const [updating, setUpdating] = useState(false);

  const isDnd = presence?.availability === "DoNotDisturb";

  const togglePresence = async () => {
    const newState = isDnd ? "Available" : "DoNotDisturb";
    try {
      setUpdating(true);
      const result = await setPresenceState(newState);

      if (result.success) {
        console.log("Presence updated:", result);
        let elapsed = 0;

        const intervalId = setInterval(() => {
          let activePS = localStorage.getItem('activePS');
          activePS = activePS ? JSON.parse(activePS) : {};
          activePS = (activePS && activePS.availability && activePS.activity) ? activePS.availability : '';

          const shouldStop = (activePS === newState) || (++elapsed >= 10); //max 10s timer
          if (shouldStop) {
            clearInterval(intervalId);
            setUpdating(false);
          }
        }, 1000);
      } else {
        console.error("Failed to update presence:", result.message);
        setUpdating(false);
      }
    } catch (err) {
      console.error("Error setting presence:", err);
      setUpdating(false);
    } finally {
      //setUpdating(false);
    }
  };

  const oofSettings = {isOutOfOffice:false, message:null}; //presence?.graph?.outOfOfficeSettings; //OOO code is working, not required for mvp, uncomment in future

  const normalizeLabel = (availability, activity) => {
    if (activity === "DoNotDisturb")return "Do not disturb";
    if (activity === "BeRightBack") return "Be right back";
    if (activity === "InACall") return "In a call";
    if (activity === "InAMeeting") return "In a meeting";
    if (activity === "Presenting") return "Presenting";
    if (activity === "OffWork") return "Offline";
	  if (availability === "AvailableIdle") return "Available";
    if (availability === "BusyIdle") return "Busy";
    return availability ?? activity ?? "Unknown";
  };

  const getPresenceIcon = (availability) => {
    switch (availability) {
      case "Available":
      case "AvailableIdle":
        return { PresenceIcon: PresenceAvailableFilled, color: tokens.colorPaletteGreenBackground3 };
      case "BeRightBack":
      case "Away":
        return { PresenceIcon: PresenceAwayFilled, color: tokens.colorPaletteMarigoldBackground3 };
      case "Busy":
      case "BusyIdle":
        return { PresenceIcon: PresenceBusyFilled, color: tokens.colorPaletteRedBackground3 };
      case "DoNotDisturb":
        return { PresenceIcon: PresenceDndFilled, color: tokens.colorPaletteRedBackground3 };
      case "Offline":
        return { PresenceIcon: PresenceOfflineRegular, color: tokens.colorNeutralForeground3 };
      case "OutOfOffice":
        return { PresenceIcon: PresenceOofRegular, color: tokens.colorPaletteMagentaBackground3 };
      case "Tentative":
        return { PresenceIcon: PresenceTentativeRegular, color: tokens.colorPaletteMarigoldBackground3 };
      case "Blocked":
        return { PresenceIcon: PresenceBlockedRegular, color: tokens.colorPaletteGrayBackground3 };
      default:
        return { PresenceIcon: PresenceUnknownRegular, color: tokens.colorNeutralForeground3 };
    }
  };
  
  /*const baseLabel = normalizeLabel(presence?.availability, presence?.activity);
  const displayState = oofSettings?.isOutOfOffice
    ? `${baseLabel}, Out of office`
    : baseLabel;*/

  const tooltipText = loading
    ? normalizeLabel("Available", "Available")
    : normalizeLabel(presence?.availability, presence?.activity);

  const {PresenceIcon, color} = loading
    ? getPresenceIcon("Available", "Available")
    : getPresenceIcon(presence?.availability, presence?.activity);

  return (
    <div className={styles.presenceContainer}>
      <div className={styles.presenceRow}>
        <div className={styles.toggleDnd}>
          <span>DND</span>
          <Switch
            checked={isDnd}
            onChange={togglePresence}
            className={styles.switchNoMargin}
          />
        </div>
        {/*{loading ? (
          <span>Loading...</span>
        ) : updating ? (
          <span>Updating...</span>
        ) : (
          <span>{displayState}</span>
        )}*/}
        <div className={styles.psIconWrapper}>
          <Tooltip content={tooltipText} relationship="label">
            <PresenceIcon style={{ color}}/>
          </Tooltip>
        </div>
      </div>
      {oofSettings?.isOutOfOffice && oofSettings?.message && (
        <div className={styles.oofMessage}>
          {oofSettings.message}
        </div>
      )}
    </div>
  );
  /*return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.3rem", maxWidth:"170px" }}>
      <div style={{ display: "flex", gap: "0.1rem", alignItems: "center" }}>
        <span>{displayState}</span>
        <Tooltip content="Toggle DND" relationship="label">
          <button
            onClick={togglePresence_OLD}
            disabled={updating}
            style={{
              background: "transparent",
              border: "none",
              cursor: updating ? "not-allowed" : "pointer",
            }}
          >
          {isDnd ? (
            <PresenceDndFilled style={{ color: "#d13438", fontSize: "18px" }} />
          ) : (
            <PresenceDndRegular style={{ color: "#616161", fontSize: "18px" }} />
          )}
          </button>
        </Tooltip>
      </div>

      {oofSettings?.isOutOfOffice && oofSettings?.message && (
        <div style={{
            maxWidth: "170px",
            wordWrap: "break-word",
            fontSize: "0.85rem",
            backgroundColor: "#F3F2F1",
            borderLeft: "4px solid #6B4C9A",
            padding: "8px",
            color: "#333",
          }}>
          {oofSettings.message}
        </div>
      )}
    </div>
  );*/
}
